import axiosInstance from "../../services/axios";
import { ActionTypes } from "../type";

export const submitRegistrationSearch =
  (searchValue, fromSearchButton = false) =>
  async (dispatch) => {
    const zone_id = Number(localStorage.getItem("zone_id"));

    try {
      let url =
        "LIS/master/list/appointment_patient?limit=10&page_no=0&is_active=true";
      if (searchValue?.appointment_id) {
        url += "&appointment_id=" + searchValue?.appointment_id;
      }
      if (searchValue?.mobile_no) {
        url += "&mobile_no=" + searchValue?.mobile_no;
      }
      if (searchValue?.membership_card_no) {
        url += "&membership_card_no=" + searchValue?.membership_card_no;
      }
      if (searchValue?.patient_name) {
        url += "&patient_name=" + searchValue?.patient_name;
      }
      if (searchValue?.dob) {
        url += "&dob=" + searchValue?.dob;
      }
      if (searchValue?.city) {
        url += "&city=" + searchValue?.city;
      }
      if (searchValue?.state) {
        url += "&state=" + searchValue?.state;
      }
      if (searchValue?.date_from) {
        url += "&date_from=" + searchValue?.date_from;
      }
      if (searchValue?.date_to) {
        url += "&date_to=" + searchValue?.date_to;
      }
      if (searchValue?.area) {
        url += "&area=" + searchValue?.area;
      }
      if (searchValue?.patient_id) {
        url += "&registration_no=" + searchValue?.registration_no;
      }
      // if (searchValue?.edit) {
      //   url += "&edit=" + searchValue?.edit
      // }

      // url += "&edit=1";

      if (!fromSearchButton) {
        url += "&edit=1";
      }

      const { data } = await axiosInstance.get(url, { params: { zone_id } });
      dispatch({
        type: ActionTypes.SUBMIT_REGISTRATION_SEARCH,
        payload: data,
      });
    } catch (err) {
      // throw err;
    }
  };

export const cleartRegistrationSearch = () => async (dispatch) => {
  dispatch({
    type: ActionTypes.CLEAR_REGISTRATION_SEARCH,
  });
};

export const submitAppointmentBookingMaster =
  (bookingData) => async (dispatch) => {
    try {
      const { data } = await axiosInstance.post(
        "LIS/master/create/appointment_booking_master",
        bookingData
      );
      dispatch({
        type: ActionTypes.SUBMIT_APPOINTMENT_BOOKING_MASTER,
        payload: data,
      });
    } catch (err) {
      console.error(err);
    }
  };
